module.exports = __webpack_public_path__ + "media/images/light_yellow_edge_2-c690fb716d949967742c3e0ae399cafe.svg";